angular.module('TetherApp').factory('formDataService', [
    '$window',
    'formTemplateService',
    function ($window, formTemplateService) {

        let callable = $window;

        /**
         * Assign the appropriate callable element based on
         * the window namespace property
         */
        let getCallableNamespace = function () {
            if ($window.hasOwnProperty('namespace')
                && $window.hasOwnProperty($window.namespace)) {
                callable = $window[$window.namespace];
            }
        }();

        /**
         * Return form errors
         * @returns {Object}
         */
        let getErrors = function () {
            if ('errors' in callable) {
                return callable.errors;
            } else {
                return undefined;
            }
        };

        /**
         * Return form input
         * @returns {Object}
         */
        let getInput = function () {
            if ('input' in callable) {
                return callable.input;
            } else {
                return undefined;
            }
        };

        /**
         * Return old form input
         * @returns {Object}
         */
        let getOldInput = function () {
            if ('oldInput' in callable) {
                return callable.oldInput;
            } else {
                return undefined;
            }
        };

        /**
         * Return data to populate the form with
         * @returns {Object}
         */
        let getPopulate = function () {
            if ('populate' in callable) {
                return callable.populate;
            } else {
                return undefined;
            }
        };

        let getTemplate = function(errors, input, populate, name) {
            if (name !== undefined) {
                return formTemplateService.formTemplate(name, errors, input, populate);
            } else if ($window.hasOwnProperty('template')) {
                return formTemplateService.formTemplate($window.template, errors, input, populate);
            }
        };

        return {
            getTemplate: getTemplate,
            getErrors: getErrors,
            getInput: getInput,
            getOldInput: getOldInput,
            getPopulate: getPopulate
        };

    }
]);
